import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocalizedPath } from "../localization/urls";

export function NotFound({ messageKey = "sheet.notFound" }: { messageKey?: "notFound.page" | "sheet.notFound" }) {
  const { t } = useTranslation();
  const path = useLocalizedPath();
  // Written as two literal t() calls, rather than t(messageKey), so tools/verify-l10n.mjs's
  // static scan (which only recognises quoted string arguments) can see both keys are in use.
  const message = messageKey === "notFound.page" ? t("notFound.page") : t("sheet.notFound");

  return (
    <section className="hero">
      <h1>{t("catalogue.title")}</h1>
      <p role="alert">{message}</p>
      <p>
        <Link to={path("/catalog")}>{t("tree.backToLedger")}</Link>
      </p>
    </section>
  );
}
